import React from 'react'
import { Card, CardBody, Row, Col, } from 'reactstrap'
import PropTypes from 'prop-types'
import { sanitizeEquitySupportUrl, } from '../../util/helpers'

const ResourceCard = ({
  cardTitle = '',
  cardText = '',
  cardType = '',
  cardIconClass = '',
  cardLink = '',
  pathname = '',
  zipcode = '',
}) => {

  let cardClass = 'resource-card-underline'
  if (cardType === 'solid'){
    cardClass = 'resource-card-solid'
  }
  let spanContent = null
  if (cardIconClass === 'transit') {
    spanContent = <span className={`resource-icon resource-icon-${cardIconClass}`}>&#xf207;</span>
  } else if (cardIconClass === 'search') {
    spanContent = <span className={`resource-icon resource-icon-${cardIconClass}`}>&#xf002;</span>
  } else if (cardIconClass === 'money') {
    spanContent = <span className={`resource-icon resource-icon-${cardIconClass}`}>&#xf155;</span>
  }

  let openInNewWindow = true
  if (cardLink && cardLink.includes('{pathname}')){
    openInNewWindow = false
  }
  let cardUrl = sanitizeEquitySupportUrl(cardLink, pathname, zipcode)
  let btnClasses = 'btn '
  if (cardType !== 'solid') {
    btnClasses += 'btn-secondary'
  } else {
    btnClasses += 'btn-neutral'
  }

  return <Card className={`h-100 ${cardClass}`}>
    <CardBody>
      {
        cardIconClass &&
        <Row>
          <Col xs={12} className={'d-flex justify-content-center'}>
            {spanContent}
          </Col>
        </Row>
      }
      {
        cardTitle &&
        <Row>
          <Col xs={12}>
            <h3 className={'heading-3 text-center'}>{cardTitle}</h3>
          </Col>
        </Row>
      }
      { cardText && 
        <Row>
          <Col xs={12}>
            <p className={'body-text text-center'}>{cardText}</p>
          </Col>
        </Row>
      }
      {
        cardUrl &&
        <Row>
          <Col xs={12} className={'text-center'}>
            { 
              openInNewWindow 
                ? <a className={btnClasses} target={'_blank'} rel={'noopener noreferrer'} href={cardUrl}>View Info</a>
                : <a className={btnClasses} href={cardUrl}>View Info</a> 
            }
          </Col>
        </Row>
      }
    </CardBody>
    { cardType !== 'solid' && <div className={'search-selected-indicator'}></div> }
  </Card>
}

ResourceCard.propTypes = {
  cardTitle     : PropTypes.string,
  cardText      : PropTypes.string,
  cardType      : PropTypes.string,
  cardIconClass : PropTypes.string,
  cardLink      : PropTypes.string,
  pathname      : PropTypes.string,
  zipcode       : PropTypes.string,
}

export default ResourceCard